export const SET_PERFORMANCE_LIST_DATA = "SET_PERFORMANCE_LIST_DATA";
export const SET_PERFORMANCE_LIST_PAGINATION = "SET_PERFORMANCE_LIST_PAGINATION";
export const SET_PERFORMANCE_LIST_FILTER = "SET_PERFORMANCE_LIST_FILTER";
export const SET_PERFORMANCE_LOADER = "SET_PERFORMANCE_LOADER";
export const RESET_PERFORMANCE_REDUCER = "RESET_PERFORMANCE_REDUCER";